import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import style from "../../assets/jss/disal-main/components/TableGeneral";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

const useStyles = makeStyles(style);
const TableGlobal = ({ items }) => {
  const classes = useStyles();

  const formattedItems = items.map((item) => {

    const totalFullyDone = parseFloat(item.totalDone) + parseFloat(item.noProgramated || 0);
    const totalCorrected = totalFullyDone - parseFloat(item.totalSegregation);

    return {
      ...item,
      totalDone: parseFloat(item.totalDone),
      totalIncidents: parseFloat(item.totalIncidents),
      totalPoints: parseFloat(item.totalPoints),
      totalPending: parseFloat(item.totalPending),
      totalWeight: parseFloat(item.totalWeight),
      totalFullyDone,
      totalCorrected: totalCorrected < 0 ? 0 : totalCorrected,
    };
  });

  return (
    <TableContainer className={classes.contentTable}>
      <Table
        className={classes.tableGeneral}
        aria-label="simple table"
      >
        <TableHead>
          <TableRow className={classes.cellOperativo}>
            <TableCell>Planta</TableCell>
            <TableCell>Programados</TableCell>
            <TableCell>Pendientes</TableCell>
            <TableCell>Finalizados</TableCell>
            <TableCell>No programados</TableCell>
            <TableCell>Peso (Ton.)</TableCell>
            <TableCell>Segregación(%)</TableCell>
            <TableCell>Incidentes</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {formattedItems.map((data, index) => (
            <TableRow key={index}>
              <TableCell>{data.miningSiteName}</TableCell>
              <TableCell>{data.totalPoints}</TableCell>
              <TableCell>{data.totalPending}</TableCell>
              <TableCell>{data.totalDone}</TableCell>
              <TableCell>{data.noProgramated || 0}</TableCell>
              <TableCell>{parseFloat(data.totalWeight / 1000).toFixed(2)}</TableCell>
              <TableCell>{data.totalFullyDone > 0 ? ((data.totalCorrected / data.totalFullyDone) * 100).toFixed(2) : 0}%</TableCell>
              <TableCell>{data.totalIncidents}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

}


export default TableGlobal;
